import { FC } from 'react'

import { Checkbox, Switch, FormControl, FormControlLabel, FormHelperText, Typography } from '@mui/material'

import { useField, useFormikContext } from 'formik'

interface IProps {
  fieldProps: {
    name: string
    label: string
    required?: boolean
  }
  sx?: any
  onChange?: any
  valueSelector?: string
  index?: number
  disabled?: boolean
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'default'
  isSwitch?: boolean
  hasLine?: boolean
}

const CheckboxField: FC<IProps> = ({
  fieldProps,
  sx = {},
  onChange,
  disabled,
  color = 'primary',
  isSwitch = false,
  hasLine = false,
  valueSelector,
  index,
}) => {
  const [field, meta] = useField(fieldProps.name)
  const { values, setFieldValue } = useFormikContext()
  const { error } = meta

  const value = valueSelector ? field.value[valueSelector] : field.value

  return (
    <FormControl 
      error={Boolean(error)} 
      className={hasLine ? 'switch-control' : ''} 
      sx={{ position: 'relative', paddingBottom: '0.7rem', ...sx }}>
      <FormControlLabel
        control={
          isSwitch ? 
            <Switch
              checked={value}
              disabled={disabled}
              color={'success'}
              sx={{ '& .MuiSvgIcon-root': { fontSize: '2rem' } }}
            />
            :
            <Checkbox
              checked={value}
              disabled={disabled}
              color={color}
              sx={{ '& .MuiSvgIcon-root': { fontSize: '2rem' } }}
            />
        }
        onChange={() => {
          let newValue = !values?.[fieldProps.name]
          
          if (valueSelector) {
            const fieldName = fieldProps.name.split('[')[0]
            newValue = {
              ...field.value,
              [valueSelector]: !values[fieldName][index][valueSelector],
            }
          }
          
          setFieldValue(
            fieldProps.name,
            newValue,
          )
          if (onChange) onChange(newValue)
        }}
        {...fieldProps}
      />
      {fieldProps?.required && (
        <Typography
          color='error'
          aria-hidden='true'
          style={{ position: 'absolute', top: 8, right: 4 }}
          className='MuiInputLabel-asterisk MuiFormLabel-asterisk css-14lvn6g-MuiFormLabel-asterisk'
        >
          *
        </Typography>
      )}
      {
        <FormHelperText style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', margin: 0 }}>
          {error}
        </FormHelperText>
      }
    </FormControl>
  )
}
export default CheckboxField
